import React, { useEffect, useState } from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { db } from './firebase';

/**
 * Component imports
 */
import Header from './components/Header';
import BottomNav from './components/BottomNav';
import Footer from './components/Footer';
import Home from './components/Home';
import UserProfile from './components/UserProfile';

function App() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {

    

    db.collection('posts').onSnapshot(snapshot => {

      setPosts(snapshot.docs.map(doc => ({

        id: doc.id,
        post: doc.data()
        
      })));
    })
  }, []);

  return (
    <div className="App">

       
    <Router>
     <Header />
      <Switch>
      <Route path="/" exact component={Home}/>
      <Route path="/profile" component={UserProfile}/>
      </Switch>
      
      <Footer />


  </Router>

       
      <BottomNav />

      </div>
  );   
}

export default App;
